import { Controller as BaseController } from "@hotwired/stimulus";
import videojs from "video.js"
import 'video.js/dist/video-js.css';

export class Controller extends BaseController {
  static values = { preview: String }

  connect() {
    this.videoPlayer = videojs("video-player", {
      controls: true,
      preload: "auto",
      fill: true,
      restoreEl: true,
      poster: this.previewValue
    });
  }

  disconnect() {
    if (this.videoPlayer) {
      this.videoPlayer.dispose();
    }
  }
}
